module.exports = __webpack_public_path__ + "static/media/edit-billing-icon.afaf825a.svg";